import type { ProducerBehaviorProfile } from '../types';

interface InputPanelProps {
  producerProfile: ProducerBehaviorProfile;
  onProducerProfileChange: (value: ProducerBehaviorProfile) => void;
  culture: string;
  onCultureChange: (value: string) => void;
  value: string;
  onChange: (value: string) => void;
}

const profileOptions: Array<{ value: ProducerBehaviorProfile; label: string }> = [
  { value: 'analitico', label: 'Analítico' },
  { value: 'diretivo', label: 'Diretivo' },
  { value: 'integrador', label: 'Integrador' },
  { value: 'expressivo', label: 'Expressivo' }
];

const cultureOptions = [
  'Soja',
  'Milho',
  'Trigo',
  'Cevada',
  'Café',
  'Algodão',
  'Feijão',
  'Sorgo',
  'Girassol',
  'Arroz',
  'Cana-de-açúcar',
  'Pastagem',
  'Outra'
];

export const InputPanel = ({
  producerProfile,
  onProducerProfileChange,
  culture,
  onCultureChange,
  value,
  onChange
}: InputPanelProps) => {
  const charCount = value.trim().length;

  return (
    <section className="panel panel--input">
      <div className="panel__filters">
        <label className="panel__field">
          <span className="panel__field-label">Perfil do produtor</span>
          <select className="panel__select" value={producerProfile} onChange={(event) => onProducerProfileChange(event.target.value as ProducerBehaviorProfile)}>
            {profileOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="panel__field">
          <span className="panel__field-label">Cultura</span>
          <select className="panel__select" value={culture} onChange={(event) => onCultureChange(event.target.value)}>
            {cultureOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="panel__heading-row">
        <label htmlFor="scenario-input" className="panel__label">
          Descreva o cenário da reunião
        </label>
        <span className="panel__counter">{charCount} caracteres úteis</span>
      </div>
      <textarea
        id="scenario-input"
        className="panel__textarea"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={`Exemplo: Renegociação com produtor de soja (2.800 ha).
Cliente focado em preço por hectare.
Temos evidência de ganho em estabilidade produtiva.
Participam produtor, gerente financeiro e agrônomo.`}
      />
      <p className="panel__helper">
        Inclua contexto da fazenda, decisor, safra, pressão competitiva, histórico da conta e objetivo do encontro. O perfil comportamental e a cultura ajudam a calibrar toda a conversa sem mexer no fluxo principal da ferramenta.
      </p>
    </section>
  );
};
